<template>
  <v-container>
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
          Breaks
        </div>    
        <br>  
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
           <span v-for="(content, index) in contents" :key="content['id']">
               {{ section }}.{{ index + 1 }} {{ content.question }} <br>
               Answer: {{ forms.break_score[index] ? 'Yes' : 'No' }} <br>
               Comment: {{ forms.break_comment[index] }} <br> <br>
            </span>
        </div>
  </v-container>
</template>
<script>
import db from '@/components/firebase.init';
import Scale from '@/components/Scale';
export default {
    props:['section','forms'],
    data(){
        return{
          contents:[
                {
                    question: "Do you take postural breaks every 30 minutes? E.g Standing, Walking",
                    parts: ['General']
                },
                {
                    question: "Do you take regular eye breaks every from looking at your monitor?",
                    parts: ['General']
                }
          ]
        }
    },
    methods:{
       
        initializeComment(){
            for(var i = 0; i < this.contents.length; i++){
                this.break_comment[i] = "";
            }
        }
    },
    components:{
        'scale' : Scale
    },
    mounted(){
        this.initializeComment();
    }
}
</script>

<style scoped>
table {
  width:100%;
}
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
th, td {
  padding: 15px;
  text-align: left;
}
table tr:nth-child(2) {
  background-color: red;
}
table tr:nth-child(3) {
 background-color: yellow;
}
table tr:nth-child(4) {
 background-color: rgb(49, 255, 49);
}
table th {
  background-color: rgb(131, 131, 131);
  color: rgb(0, 0, 0);
}

.form1table {
    position:absolute;
    top: 500px;
}

@media only screen and (max-width: 700px){
.form1table {
    position:relative;
    top: auto;
}
}
</style>

